import Field from "@/includes/fields/Field";

export default class TextAreaField extends Field {

    placeholder: string;

    constructor(label: string, value: string, placeholder = 'Insira sua resposta') {
        super(label, value);
        this.placeholder = placeholder
    }


    isEmpty(): boolean {
        return '' === this.getValue();
    }

    clear = (): Field => {
        this.setValue('')
        return this;
    };

    getType = (): string => "textarea";
}